import {
  removeAllVuePreloadHiddenClasses,
  elementExists
} from './util';
import AsprheProduct from './components/post-type-asprhe_product';

removeAllVuePreloadHiddenClasses();

[
  AsprheProduct
].forEach(file => {
  if (elementExists(file.test)) {
    file.vue();
  }
});
